import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"normal","font-size":"14px"} }, "指标", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_7 = {
  class: "card-body pt-0",
  style: {"padding-bottom":"0"}
}
const _hoisted_8 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_9 = { class: "card-body pt-0" }
const _hoisted_10 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_11 = { class: "table-responsive" }

import {ref, onMounted, reactive, watch} from "vue";
import {getCSSVariableValue} from "@/assets/ts/_utils";
import { renderThousands } from '@/utils';

// 表格载入延迟

export default /*#__PURE__*/_defineComponent({
  props: {
  field: { type: String, required: true },  // 指定的指标字段
  data: {type: Array, required: true},  // 图形属性
  fields: {type: Array, required: true},  // 可选的所有指标
},
  emits: ['drill-down'],
  setup(__props, { emit }) {

const props = __props

const loading = ref<boolean>(false);
const chart = ref<HTMLElement | null>(null);


const filter = reactive({
  field: props.field,
});
const title = ref<string>('');
const labelColor = getCSSVariableValue("--bs-" + "gray-800");
const strokeColor = getCSSVariableValue("--bs-" + "gray-300");
const baseColor = getCSSVariableValue("--bs-" + "primary");
const lightColor = getCSSVariableValue("--bs-light-" + "primary");
const series = ref<Array<any>>([]);
const options = reactive({
  chart: {
    type: 'bar',
    events: {
      dataPointSelection: function (e, chart, opts) {
        emit('drill-down', opts.w.globals.categoryLabels[opts.dataPointIndex]);
      }
    }
  },
  plotOptions: {
    bar: {
      isDumbbell: true,
      rangeBarOverlap: false,
    }
  },
  legend: {
    show: true,
    height: 50,
  },
  dataLabels: {
    enabled: false,
    // enabledOnSeries: [1],
  },
  labels: [] as any[],  //横坐标数组
  fill: {
    type: 'solid',
    opacity: 1,  //不透明度
  },
  xaxis: {
    type: 'category',
    labels: {
      show: true,
      hideOverlappingLabels: false,
      rotateAlways: true,
      rotate: -45
    },
  },
  yaxis: [{
    forceNiceScale: true,
  },
  {
    opposite: true,
    forceNiceScale: true,
    labels: {
      formatter: function(val, index) {
        return val.toFixed(2) + '%';
      }
    }
  }],
});
const tableHeader = ref<Array<any>>([]);
const tableData = ref<Array<any>>([]);

onMounted(() => {
});

watch(props, (val) => {
  if (props.data.length > 0) {
    let fields = [] as string[];
    for (let f of props.fields as []) {
      fields.push(f['field']);
    }
    if (fields.indexOf(filter.field) === -1) {
      filter.field = fields[0];
    }
    title.value = (props.fields as any[]).find(x => {return x['field'] === filter.field})['name'];
    loadData();
  }
});

// 数据载入
const loadData = () => {
  loading.value = true;
  let xfields = [] as string[];
  if (props.data.length > 0) {
    for (let k in props.data[0] as any) {
      xfields.push(k)
    }
  }
  loading.value = false;
  options.labels = [...xfields];
  (chart as any).value.updateOptions(options);
  changeSeries();
}

// 改变图表数据
const changeSeries = () => {
  let data1 = [] as any[], data2 = [] as any[];
  title.value = (props.fields as any[]).find(x => {return x['field'] === filter.field})['name'];
  series.value = [];
  if (props.data.length > 0 && JSON.stringify(props.data[0]) != '{}') {
    tableHeader.value = ['名称'];
    tableData.value = [{名称: '差额'}, {名称: '幅度'}];
    for (let k in props.data[0] as any) {
      data1.push(props.data[0][k][filter.field]);
      tableHeader.value.push(k);
      tableData.value[0][k] = props.data[0][k][filter.field];
    }
    for (let k in props.data[1] as any) {
      data2.push(props.data[1][k][filter.field]);
      tableData.value[1][k] = props.data[1][k][filter.field];
    }
  }
  series.value.push({
    name: '差额',
    type: 'bar',
    data: data1,
  });
  series.value.push({
    name: '幅度',
    type: 'line',
    data: data2,
  });
  (chart as any).value.updateSeries(series.value);
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(title.value), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_el_select, {
          modelValue: _unref(filter).field,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filter).field) = $event)),
          size: "small",
          placeholder: "请选择指标",
          onChange: changeSeries,
          style: {"width":"180px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.fields, (v) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                value: v['field'],
                key: v['field'],
                label: v['name']
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_apexchart, {
          ref_key: "chart",
          ref: chart,
          type: "area",
          height: "300",
          options: _unref(options),
          series: series.value,
          class: "mixed-widget-7-chart card-rounded-bottom"
        }, null, 8, ["options", "series"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_table, {
            data: tableData.value,
            style: {"margin-top":"-15px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableHeader.value, (k) => {
                return (_openBlock(), _createBlock(_component_el_table_column, {
                  key: k,
                  label: k,
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _renderSlot(_ctx.$slots, `cell-${k}`, {
                      row: scope.row
                    }, () => [
                      _createTextVNode(_toDisplayString(_unref(renderThousands)(scope.row[k])), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 3
          }, 8, ["data"])
        ])
      ])
    ])
  ]))
}
}

})